<template>
  <div id="large-map" @mouseout="hideToolTip">
   <dashboard-toggler/>
   <div class="extra-tools">
      <div v-if="hasPlan" class="ol-zoom-extent ol-unselectable ol-control" style="pointer-events: auto;">
         <button @click="zoomToPlan" type="button" title="Zoom to plan">
            <span style="display: flex; justify-content: center; align-items: center;">
               <img src="@/assets/icons/project-extent.svg">
            </span>
         </button>
      </div>
   </div>
   <div class="selectors-wrapper">
      <base-layer-selector large/>
      <template v-if="showScratchTools">
         <select-bat-tool/>
         <select-mhp-tool/>
         <select-sst-tool/>
      </template>
   </div>
   <div :id="toolTipId" class="map-tooltip" ref="tooltip"/>
   <bat-point-query-popup/>
  </div>
</template>

<script>
import DashboardToggler from '@/components/atoms/Home/DashboardToggler';
import BaseLayerSelector from '@/components/molecules/Home/BaseLayerSelector';
import SelectBatTool from '@/components/molecules/Home/MepToolMap/SelectBATTool';
import SelectMhpTool from '@/components/molecules/Home/MepToolMap/SelectMHPTool';
import SelectSstTool from '@/components/molecules/Home/MepToolMap/SelectSSTTool';
import BatPointQueryPopup from '@/components/organisms/Home/BatPointQueryPopup';
import { animateToPoint } from '@/js/map';
import { BAT,MHP,SST } from '@/store/modules/tools';
import { TOOLTIP_ID } from '@/js/tools/tooltip';
import { mapGetters,mapActions } from 'vuex';
import { selectMunicipalityFromTop } from '@/js/mapNavigator';

export default {
   components: {
      DashboardToggler,
      BaseLayerSelector,
      SelectBatTool,
      SelectMhpTool,
      BatPointQueryPopup,
      SelectSstTool,
   },
   computed: {
      ...mapGetters('tools', ['getCurrentTool', 'getAllTools']),
      ...mapGetters('plan', ['hasPlan', 'getPlan']),
      toolTipId()
      {
         return TOOLTIP_ID;
      },
      showScratchTools()
      {
         return this.$route.name==='home'
      }
   },
   methods: {
      ...mapActions('tools', ["setCurrentTool"]),
      zoomToLocation(location)
      {
         animateToPoint(location);
      },
      zoomToPlan()
      {
         console.assert(this.getPlan && this.getPlan.municipality, `Invalid municiaplity or plan in zoom to plan ${this.getPlan && this.getPlan.municipality && this.getPlan.municipality.sddmm}`)
         selectMunicipalityFromTop(this.getPlan.municipality.sddmm);
      },
      isBAT(tool)
      {
         return tool===BAT;
      },
      isSST(tool)
      {
         return tool===SST;
      },
      isMHP(tool)
      {
         return tool===MHP;
      },
      hideToolTip()
      {
         const { tooltip } = this.$refs;
         tooltip.style.opacity = '0';
      },
   }
}
</script>

<style lang="scss">
#large-map {
   position: relative;
   background: $secondary-bg;
   width: 100%;
   height: 100%;
   border: 1px solid lighten($secondary-color, 25%);
   border-radius: 4px;
   overflow: hidden;
   
   .extra-tools {
      position: absolute;
      top: 1.6em;
      z-index: 1;
   }

   .plan-actions {
      position: absolute;
      bottom: 0.5em;
      left: 0.5em;
      z-index: 1;
      button {
         border: solid 3px white;
         background: $primary-color;
         margin-right: 3px;
         outline: none;
         border: none;
         padding: 5px;
         border-radius: 2px;
         cursor: pointer;
      }
   }

   .map-tooltip {
      position: absolute;
      font-family: $primary-font;
      color: white;
      top: 0;
      left: 100%;
      font-size: 13px;
      padding: 7px;
      width: max-content;
      text-align: left;
      max-width: 300px;
      z-index: 1;
      display: none;
      pointer-events: none;
      border-radius: 5px;
      transform: translate(15px,-50%);
      transition: 0.3s;
      
      &, &::after {
         background: rgba($primary-color, 0.75);
      }
      &::after {
         content: " ";
         $width: 8px;
         $height: 12px;
         position: absolute;
         top: 50%;
         transform: translateY(-50%);
         left: -$width;
         width: $width;
         height:$height;
         clip-path: polygon(0% 50%, 100% 100%, 100% 0%);
      }
   }
}

.selectors-wrapper {
   position: absolute;
   z-index: 2;
   right: 0em;
   top: 0em;
   background: $primary-color;
}
</style>